import React, { useEffect, useState } from "react";
import { updateDestination } from "../../api/Destination";
import Swal from "sweetalert2";

const EditDestination = ({ onSuccess, destination }) => {
  const [destinationNameValue, setDestinationNameValue] = useState({
    id: "",
    destination_name: "",
  });

  useEffect(() => {
    setDestinationNameValue({
      id: destination?._id,
      destination_name: destination?.destination_name,
    });
  }, [destination]);

  const handleChange = (e) => {
    setDestinationNameValue((prevState) => ({
      ...prevState,
      destination_name: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = updateDestination(destinationNameValue);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Destination Updatd Successfully!",
            text: "You have successfully updated a destination!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="text-left">
        <div className="form-group">
          <label>Destination Name</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputDestination"
            value={destinationNameValue.destination_name}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Update
        </button>
      </form>
    </>
  );
};

export default EditDestination;
